import { render, staticRenderFns } from "./UserFormQuota.vue?vue&type=template&id=d14c331a"
import script from "./UserFormQuota.vue?vue&type=script&lang=js"
export * from "./UserFormQuota.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports